import { BASE_URL, EMPLOYEE_COMPETENCIES } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { IEmployeeCompetencyInput } from "models/employeeCompetencies";

export async function getEmployeeCompetencies(params: string = "") {
  const response = await axios.get(BASE_URL + EMPLOYEE_COMPETENCIES + params);
  return response.data;
}
export async function addEmployeeCompetency(data: IEmployeeCompetencyInput) {
  const response = await axios.post(BASE_URL + EMPLOYEE_COMPETENCIES, data);
  return response.data;
}
export async function editEmployeeCompetency(data: IEmployeeCompetencyInput, id: string) {
  
  const response = await axios.patch(BASE_URL + EMPLOYEE_COMPETENCIES + "/" + id, data);
  return response.data;
}

export async function deleteEmployeeCompetency(id: string) {
  const response = await axios.delete(BASE_URL + EMPLOYEE_COMPETENCIES + "/" + id);
  return response.data;
}

export async function getCompetenciesAcquireSources() {
  const response = await axios.get(BASE_URL + EMPLOYEE_COMPETENCIES + '/acquireources');
  return response.data;
}

export const EmployeeCompetencyCells: HeadCell[] = [
  {
    id: "competencyName",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "acquireSource",
    numeric: false,
    disablePadding: false,
    label: "T_acquire_source",
  },
  {
    id: "verified",
    numeric: false,
    disablePadding: false,
    label: "T_verified",
  },
 
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
